export const FREQUENCIA_ALERTA_MOVIMENTACAO_MAP = {
  1: "Não enviar",
  2: "Semanal",
  3: "Mensal",
};

export const FREQUENCIA_ALERTA_MOVIMENTACAO_OPTIONS = Object.entries(FREQUENCIA_ALERTA_MOVIMENTACAO_MAP).map(
  ([value, descricao]) => ({
    value: Number(value),
    descricao,
  })
);
